
import invoke from '../utils/invoke';

export const holdersCount = () => {
    return invoke({
        url : `https://api.explorer.nucoin.com.au/v1/api/account/wallet/count`,
        method  :   'GET'
    })
}
